





























































import Vue from "vue";
import { mapGetters } from "vuex";
import {updateClassified} from "@/shared/scripts/ValidateData";
import {deleteOrderPublishPictures} from "@/shared/scripts/UploadPicture";
import { Trans } from "@/shared/scripts/helpers/translation/translation";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";

export default Vue.extend({
    computed: {
        ...mapGetters({
            isMasquerading: "UserModule/isMasquerading",
        }),
        classifiedId: function(): string {
            return this.$store.getters["FormModule/getClassifiedId"];
        },
        urlPreview: function(): string {
            return `${process.env.VUE_APP_IMMOWEB_URL}`
                + `/${Trans.currentLocale}`
                + `${process.env.VUE_APP_CLASSIFIEDS_MANAGEMENT_PREVIEW_URL}${this.$t("classified")}`
                +`/${this.classifiedId}`;
        }
    },

    methods: {
        openPreview: function() {
            if(this.urlPreview) {
                window.open(this.urlPreview, "_blank");
                let computedUrl = this.urlPreview as string;
                window.open(computedUrl, "_blank");
            }
        },
        saveDraft: function() {
            deleteOrderPublishPictures(false).then(() => {
                updateClassified((success: boolean) => {
                    if(success) {
                        // GTM stats
                    }
                });
            }).catch(() => {
                this.dialog.alert(i18n.t("server_not_responding_error").toString());
            });
        }
    }


});
